// SAFE-WRITE-BEGIN: frontend/src/pages/valuation/_SnapshotDownload.tsx
/** VAL-SNAPSHOT-2: the owner's paid Snapshot download (shown only once the grant exists). */
import { useState } from 'react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { downloadSnapshot } from '@/api/valuationB3'
import { formatApiError } from '@/utils/httpErrors'

export function SnapshotDownloadButton({ engagementId }: { engagementId: string }) {
  return <PaidDownloadButton fetch={() => downloadSnapshot(engagementId)} label="Download snapshot" />
}

/** VAL-TIERS-1-2: one download button for every paid owner document (Snapshot, Tier 1, Tier 2). */
export function PaidDownloadButton({ fetch, label, variant }: {
  fetch: () => Promise<{ blob: Blob; filename: string }>
  label: string
  variant?: 'outline'
}) {
  const [busy, setBusy] = useState(false)

  async function onClick() {
    setBusy(true)
    try {
      const { blob, filename } = await fetch()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      URL.revokeObjectURL(url)
    } catch (err) {
      toast.error(formatApiError(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <Button className="w-full" variant={variant} disabled={busy} onClick={onClick}>
      {label}
    </Button>
  )
}
// SAFE-WRITE-EOF: frontend/src/pages/valuation/_SnapshotDownload.tsx
